;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Ladder = Backbone.Model.extend({
		sort_key:   'rank',
		sort_order: false,

		url: function() {
			return this.methodUrl;
		},

		isNew: function(){
			return true;
		},

		loadSnapshot: function() {
			return this.setApiUrl('tipping_stats/show_snapshot');
		},

		league_ladder: function() {
			return this.setApiUrl('tipping_league/ladder');
		},

		store_ladder() {
			return this.setApiUrl('tipping_league/regional_ladder');
		},

		getUserLadder: function() {
			return this.setApiUrl('ladder_predictor/show_my_saved');
		},
		
		sortLeagueLadder: function(field) {
			var ladder = this.get('ladder');

			if (this.sort_key == field) {
				this.sort_order = !this.sort_order;
				ladder = ladder.reverse();
			}
			else {
				this.sort_key = field;
				ladder = _.sortBy(ladder, this.sort_key);
				if ($.inArray(this.sort_key, ['rank', 'name']) == -1) {
					ladder = ladder.reverse();
				}
			}

			this.set('ladder', ladder);

			return this;
		},

		pseudoSortLeagueLadder: function(field) {
			var ladder = this.get('ladder');

			if (this.sort_key == field) {
				this.sort_order = !this.sort_order;
			}
			else {
				this.sort_key = field;

			}

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));